<template>
  <div class="panel-head">
    <div class="ph-title">{{ title }}</div>
    <div v-if="label" class="ph-label">{{ label }}</div>
  </div>
</template>

<script>
/**
 * Reusable panel header leaf.
 *
 * Renders the uppercase title at the top of each of the three workspace
 * panels (CONTEXT / WORKSPACE / RESULTS). `label` is optional — when omitted
 * the right-side tag is not rendered and the title aligns naturally to the
 * left without an empty space on the right.
 *
 * Styles mirror the Claude Design wireframe `.panel-head` block
 * (AVA Verification Wireframe.html lines 91-96).
 */
export default {
  name: 'PanelHeader',
  props: {
    title: { type: String, required: true },
    label: { type: String, default: '' },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/verification-tokens';

.panel-head {
  // Padding matches wireframe (14px vertical). Font sizes reduced from
  // wireframe baseline per user feedback that the title text read too large
  // in real-browser typography. line-height:1 prevents inherited body
  // line-height (1.45) from inflating the cap-height cell around uppercase
  // text.
  padding: 12px 16px;
  line-height: 1;
  border-bottom: 1px solid $vf-line-soft;
  display: flex;
  align-items: center;
  justify-content: space-between;

  // Prefixed class names (ph-* = panel-head) to avoid collision with
  // Vuetify 2's global `.v-application .title` utility which sets a
  // ~20px font-size + `!important` and defeats scoped `.title` rules
  // at equal specificity.
  .ph-title {
    font-family: $vf-font-heading;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    font-size: 13px;
    line-height: 1;
    color: $vf-ink-2;
  }

  .ph-label {
    font-family: $vf-font-mono;
    font-size: 10px;
    letter-spacing: 0.12em;
    line-height: 1;
    color: $vf-ink-3;
  }
}
</style>
